import { render, staticRenderFns } from "./Asteroid3.vue?vue&type=template&id=a3bf1760&scoped=true&"
import script from "./Asteroid3.vue?vue&type=script&lang=js&"
export * from "./Asteroid3.vue?vue&type=script&lang=js&"
import style0 from "./Asteroid3.vue?vue&type=style&index=0&id=a3bf1760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf1760",
  null
  
)

export default component.exports